// const FREE = 'Free';
const PRO = 'Pro';
const PREMIUM = 'Premium';
// const ENTERPRISE = 'Enterprise';

export const getPlanUpgrade = (feature) => {
  switch (feature) {
    case 'PLUGIN_MANAGEMENT_ENABLED':
      return PRO;
    case 'PLUGIN_REMOVE_LOGO_ENABLED':
    case 'PLUGIN_STYLES_EDITING_ENABLED':
      return PREMIUM;
    default:
      return '';
  }
};



// WEBPACK FOOTER //
// ./src/utils/plan-helpers.js